import { subscriptionActionTypes, userActionTypes } from '../actions/types';
import { planService, subscriptionService, invoiceService } from '../services';
import _ from 'lodash';

const resetState = () => {
  return dispatch => dispatch({ type: subscriptionActionTypes.RESET_STATE });
};

const getCurrentSubscription = (params) => {
  return (dispatch, getState) => {
    dispatch(request());

    const userId = getState().authentication.user.userId;
    const query = {
      status: _.get(params, 'status', 'active'),
      expand: _.get(params, 'expand', 'plan'),
    };


    subscriptionService.findAll(userId, query).then(
      subscriptions => {
        if (_.get(subscriptions, 'length', 0) > 0) {
          let remainedDays = 0;
          let hasSubscription = false;
          let currentActiveSubscription;
          subscriptions.forEach(subscription => {
            const diffTime = Date.parse(subscription.currentPeriodEnd) - Date.now();
            if (subscription.status === 'active' && subscription.plan.active && diffTime > 0) {
              if (!currentActiveSubscription) currentActiveSubscription = subscription;
              remainedDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
              hasSubscription = true;
            }
          });
          dispatch(success(currentActiveSubscription, hasSubscription, remainedDays));
        } else {
          dispatch(success(undefined, false, 0));
        }
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            subscriptionActionTypes.GET_CURRENT_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: subscriptionActionTypes.GET_CURRENT_REQUEST };
  }
  function success(subscription, hasSubscription, subRemainedDays) {
    return {
      type: subscriptionActionTypes.GET_CURRENT_SUCCESS,
      subscription,
      hasSubscription,
      subRemainedDays,
    };
  }
};

const getUserSubscription = (userId, params) => {
  return (dispatch, getState) => {
    dispatch(request());
    const query = _.has(params, 'status') ? {
      status: _.get(params, 'status', 'active'),
      expand: _.get(params, 'expand', 'plan'),
    } : {
      expand: _.get(params, 'expand', 'plan'),
    };


    return subscriptionService.findAll(userId, query).then(
      subscriptions => {
        const subscriptionList = Array.isArray(subscriptions) ? subscriptions : [];
        const currentActiveSubscription = subscriptionList
          .filter(subscription => (
            subscription.status === 'active'
            && _.get(subscription, 'plan.active', false)
            && Date.parse(subscription.currentPeriodEnd) > Date.now()
          ))
          .sort((first, second) => (
            Date.parse(second.currentPeriodEnd) - Date.parse(first.currentPeriodEnd)
          ))[0];
        const remainedDays = currentActiveSubscription
          ? Math.ceil((Date.parse(currentActiveSubscription.currentPeriodEnd) - Date.now())
            / (1000 * 60 * 60 * 24))
          : 0;

        dispatch(success(
          subscriptionList,
          currentActiveSubscription,
          Boolean(currentActiveSubscription),
          remainedDays,
        ));
        return subscriptionList;
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            subscriptionActionTypes.GET_USER_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
        throw error;
      },
    );
  };

  function request() {
    return { type: subscriptionActionTypes.GET_USER_REQUEST };
  }
  function success(subscriptions, subscription, hasSubscription, subRemainedDays) {
    return {
      type: subscriptionActionTypes.GET_USER_SUCCESS,
      subscriptions,
      subscription,
      hasSubscription,
      subRemainedDays,
    };
  }
};

const getListOfSubscriptions = currency => {
  return (dispatch, getState) => {
    dispatch(request());

    planService.getListOfSubscription(currency).then(
      subscriptions => {
        dispatch(success(subscriptions));
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            subscriptionActionTypes.FETCH_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: subscriptionActionTypes.FETCH_REQUEST };
  }
  function success(subscriptions) {
    return { type: subscriptionActionTypes.FETCH_SUCCESS, subscriptions };
  }
};

const addSubscription = (subscribe) => {
  return async (dispatch, getState) => {
    dispatch(request());
    const userId = subscribe.userId;

    try {
      const invoice = await subscriptionService.create(userId, {
        user: userId,
        plan: subscribe.plan,
      });
      dispatch(success(invoice));
      await dispatch(getUserSubscription(userId));
      return invoice;
    } catch (error) {
      dispatch(
        _refreshTokenOnFailure(
          error,
          subscriptionActionTypes.CREATE_FAILURE,
          getState().authentication.pendingRefreshingToken,
        ),
      );
      throw error;
    }
  };

  function request() {
    return { type: subscriptionActionTypes.CREATE_REQUEST };
  }
  function success(invoice) {
    return {
      type: subscriptionActionTypes.CREATE_SUCCESS,
      invoice,
    };
  }
};

const findAll = () => {
  return (dispatch, getState) => {
    dispatch(request());
    // const userId = getState().authentication.user.userId;
    subscriptionService
      .findAll()
      .then(
        list => {
          dispatch(success(list));
        },
        error => {
          dispatch(
            _refreshTokenOnFailure(
              error,
              subscriptionActionTypes.FETCH_LIST_FAILURE,
              getState().authentication.pendingRefreshingToken,
            ),
          );
        },
      );
  };

  function request() {
    return { type: subscriptionActionTypes.FETCH_LIST_REQUEST };
  }
  function success(list) {
    return {
      type: subscriptionActionTypes.FETCH_LIST_SUCCESS,
      list,
    };
  }
};

const cancelDraftSubscription = () => {
  return (dispatch, getState) => {
    dispatch(request());

    const userId = getState().authentication.user.userId;
    const subscriptionId = getState().subscription.invoice.subscription._id;
    subscriptionService._delete(userId, subscriptionId).then(
      () => {
        dispatch(success());
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            subscriptionActionTypes.CANCEL_DRAFT_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: subscriptionActionTypes.CANCEL_DRAFT_REQUEST };
  }
  function success() {
    return { type: subscriptionActionTypes.CANCEL_DRAFT_SUCCESS };
  }
};

const useCoupon = ({ couponCode, planId }) => {
  return (dispatch, getState) => {
    dispatch(request());

    const user = getState().authentication.user;
    const subscriptionId = getState().subscription.invoice.subscription._id;
    let userId = null;
    if (user.role === 'client') {
      userId = user.userId;
    }

    subscriptionService.update(userId, { id: subscriptionId, couponCode, planId }).then(
      invoice => {
        dispatch(success(invoice));
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            subscriptionActionTypes.USE_COUPON_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: subscriptionActionTypes.USE_COUPON_REQUEST };
  }
  function success(invoice) {
    return { type: subscriptionActionTypes.USE_COUPON_SUCCESS, invoice };
  }
};

const payInvoice = bilingInformation => {
  return (dispatch, getState) => {
    dispatch(request());

    const invoiceId = getState().subscription.invoice._id;
    invoiceService.pay(invoiceId, bilingInformation).then(
      response => {
        if (response.location) window.location.href = response.location;
        else dispatch(success());
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            subscriptionActionTypes.PAY_INVOICE_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: subscriptionActionTypes.PAY_INVOICE_REQUEST };
  }
  function success() {
    return { type: subscriptionActionTypes.PAY_INVOICE_SUCCESS };
  }
};

const _refreshTokenOnFailure = (error, failureAction, pendingRefreshToken) => {
  if (error.error === 'jwt expired') {
    if (pendingRefreshToken) {
      return {
        type: userActionTypes.PENDING_REFRESH_TOKEN,
        error,
      };
    } else {
      return { type: userActionTypes.INVALID_TOKEN, error };
    }
  } else {
    return { type: failureAction, error };
  }
};

export const subscriptionActions = {
  resetState,
  getListOfSubscriptions,
  addSubscription,
  cancelDraftSubscription,
  useCoupon,
  payInvoice,
  getCurrentSubscription,
  getUserSubscription,
  findAll,
};
